import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { googleOAuthAPI } from '../../components/LoginWithGoogleButton/ApiService';
import { useCookies } from 'react-cookie';

export default function GoogleOAuth() {
    const location = useLocation();
    const navigate = useNavigate();

    const [cookies, setCookie] = useCookies(["access_token"]);

    const params = new URLSearchParams(location.search);

    useEffect(() => {
        googleOAuthAPI(params.get('state') ?? '', params.get('code') ?? '', params.get('scope') ?? '').then(resp => {
            if (resp.status === 200 && resp.data && resp.data.isSuccess) {
                let expires = new Date();
                expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000);

                setCookie("access_token", resp.data.token, {
                    path: "/",
                    expires: expires,
                    maxAge: 7 * 24 * 60 * 60,
                    secure: true,
                    sameSite: "strict",
                })

                navigate("/home")
            }
        }).catch(e => console.error)
    }, [])

    return (
        <></>
    )
}